export function payroll(api: ReturnType<typeof useAxios>) {
  const getPayroll = async (data: any) => await api.$get(`/pay-roll?startdate=${data.fromdate}&enddate=${data.todate}&search=${encodeURIComponent(data.search)}&limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}`);

  const exportEmployeeAttendenceSheet = async (data: any) =>
    await api.post(`/attendance-report`, data, { responseType: 'blob',
    });

  return {
    getPayroll,
    exportEmployeeAttendenceSheet,
  };
}
